import React, { useState } from 'react'
import { useTranslation } from 'react-i18next';
import { ScrollView, Text, View } from 'react-native'
import { useCssStyle } from '../../customHook/getCssStyle';
import HeaderWithBack from '../../components/Header/headerWithBack';
import { ImageComp } from '../../components/Image/Image';
import { getCleanUrl, toBool } from '../../utils/Helper';
import CustomPressable from '../../components/customPressable/customPressable';
import { makeStringStrictlyCapitalize } from '../../js/utility';
import { CustomTextInput } from '../../components/customTextInput';
import CustomCheckBoxWithProps from '../../components/checkBox/customCheckBox';
import { useSelector } from 'react-redux';
import { HEART } from '../../assets';



const SpaBooking1a = (props) => {
    const { currentWidget, bookingObj, handleNext, handleGoBack} = props;

    const { t } = useTranslation();
    const getStyles = useCssStyle();

    const { currencyDetails } = useSelector(state => state.deviceConfigSlice);
    const currencyCode = currencyDetails.code;

    

    const [selectedService, setSelectedService] = useState(bookingObj?.selectedService);
    const [allServicesdata, setAllServiesData] = useState(bookingObj?.serviceGroupData);
    const [isAllFilterSelected, setIsAllFilterSelected] = useState(true);



    return (
      <View style={getStyles(['widgetRootContainer', 'spaBookingRootContainer'])} id='spaBookingRootContainer'>
        <HeaderWithBack handleCustomBackPress={handleGoBack} />

        <ScrollView
          automaticallyAdjustKeyboardInsets={true} 
          contentContainerStyle={getStyles(['widgetmainContainer', 'spaBookingMainContainer'])} 
          showsVerticalScrollIndicator={false}
          id='spaBookingMainContainer'
        >
          <View style={getStyles(['widgetmainContainerHeaderContainer', 'spaBookingHeaderContainer'])} id='spaBookingHeaderContainer'>
            {
              currentWidget?.widgetHeaderImageUrl && 
                <ImageComp
                  source={getCleanUrl(currentWidget?.widgetHeaderImageUrl)} 
                  style={getStyles(['widgetmainContainerHeaderImg', 'spaBookingHeaderImg'])} id={"spaBookingHeaderImg"}
                />
            }
            <View style={getStyles(['widgetmainContainerHeaderTitleContainer', 'spaBookingHeaderTitleContainer'])} id='spaBookingHeaderTitleContainer'>
              <ImageComp source={HEART} style={getStyles(["spaBookingHeaderTitleImage"])} id="spaBookingHeaderTitleImage"/>
              <Text style={getStyles(['widgetmainContainerHeaderTitle', 'spaBookingHeaderTitle'])} id='spaBookingHeaderTitle'>
                {t("spaBooking.create_booking.heading")}
              </Text>
              <Text style={getStyles(['widgetmainContainerHeaderSubTitle', 'spaBookingHeaderSubTitle'])} id='spaBookingHeaderSubTitle'>
                {t("spaBooking.create_booking.subheading")}
              </Text>
              <View style={getStyles(["horizontalline"])} id='horizontalline'></View>
            </View>

            <View style={getStyles(["spaBookingFitlerContainerPillContainer"])} id="spaBookingFitlerContainerPillContainer">
              <ScrollView 
                automaticallyAdjustKeyboardInsets={true} 
                horizontal
                showsHorizontalScrollIndicator={false}
                contentContainerStyle={getStyles(["spaBookingFitlerContainer"])} id='spaBookingFitlerContainer'
              >
                <CustomPressable 
                  style={getStyles(["spaBookingFitlerButtonContainer", isAllFilterSelected ? "spaBookingFitlerButtonContainerSelected" : ""])} 
                  id="spaBookingFitlerButtonContainer spaBookingFitlerButtonContainerSelected"
                  onPress={()=> {
                    setIsAllFilterSelected(true);
                    setAllServiesData(bookingObj?.serviceGroupData);
                  }}
                >
                  <Text style={getStyles(["spaBookingFitlerButtonText", isAllFilterSelected ? "spaBookingFitlerButtonTextSelected" : ""])} id='spaBookingFitlerButtonText spaBookingFitlerButtonTextSelected'>All</Text>
                </CustomPressable>
              
                {
                  bookingObj?.serviceGroupData?.map((data, index)=> {
                    return areAllServiceInDataNoShow(data) ? <></>
                    : <CustomPressable 
                        style={getStyles(["spaBookingFitlerButtonContainer", !isAllFilterSelected && allServicesdata && data.name == allServicesdata[0].name ? "spaBookingFitlerButtonContainerSelected" : ""])} 
                        id="spaBookingFitlerButtonContainer"
                        onPress={()=> {
                          setIsAllFilterSelected(false);
                          setAllServiesData([data]);
                        }}
                      >
                        <Text style={getStyles(["spaBookingFitlerButtonText", !isAllFilterSelected && allServicesdata && data.name == allServicesdata[0].name ? "spaBookingFitlerButtonTextSelected" : ""])} id='spaBookingFitlerButtonText spaBookingFitlerButtonTextSelected'>{data.name}</Text>
                      </CustomPressable>
                  })
                }
              </ScrollView>
            </View>
          </View>


          <View style={getStyles(['widgetmainContainerChildContainer', 'spaBookingMainContainerChildContainer'])} id='spaBookingMainContainerChildContainer'>
            <View style={getStyles(["spaBooking1aListContainer"])} id='spaBooking1aListContainer'>
              {allServicesdata?.map((data, index) => {
                return areAllServiceInDataNoShow(data) ? <></>
                : <View style={getStyles(["spaBooking1aListItemContainer"])} id='spaBooking1aListItemContainer'>
                    <Text style={getStyles(["spaBooking1aListItemName"])} id='spaBooking1aListItemName'>{`${makeStringStrictlyCapitalize(data.name)}`}</Text>
                    
                    {data.services?.map((service)=> {
                      const bookingShowType = getBookingShowType(toBool(service.onlineEnabled) , toBool(service.callToBook));

                      if(bookingShowType=== "NOSHOW") return <></>

                      else if(bookingShowType=== "OFFLINE"){
                        return <View style={getStyles(["list_itemContainer", "spaBooking1aOfflineListItem"])} id='spaBooking1aOfflineListItem'>
                            <Text style={{ fontFamily: 'FontAwesome', fontSize: 24 }}>
                              📞
                            </Text>

                            <View style={getStyles(["list_itemContainer_textContainer", "spaBooking1aOfflineListItemDetailsContainer"])} id='spaBooking1aOfflineListItemDetailsContainer'>
                              <Text style={getStyles(["list_itemContainer_textContainer_title", "spaBooking1aOfflineListItemName"])} id='spaBooking1aOfflineListItemName'>{makeStringStrictlyCapitalize(service.name)}</Text>
                              <Text style={getStyles(["list_itemContainer_textContainer_subtitle", "spaBooking1aOfflineListItemDescription"])} id='spaBooking1aOfflineListItemDescription'>{service.description}</Text>

                              <Text style={getStyles(["spaBooking1aOfflineListItemContactLabel"])}>{t(`spaBooking.contact_hotel`)}</Text>

                              <View style={getStyles(["spaBooking1aOfflineListItemDetails"])} id='spaBooking1aOfflineListItemDetails'>
                                <Text style={getStyles(["spaBooking1aOfflineListItemDetailsDuration"])} id='spaBooking1aOfflineListItemDetailsDuration'>
                                  {`${service.duration} ${t("spaBooking.minutes")}`}
                                </Text>

                                <Text style={getStyles(["spaBooking1aOfflineListItemDetailsPrice"])} id='spaBooking1aOfflineListItemDetailsPrice'>
                                  {`${currencyCode} ${service.price}`}
                                  <Text style={getStyles(["spaBooking1aOfflineListItemDetailsPricePerson"])} id='spaBooking1aOfflineListItemDetailsPricePerson'>
                                    {t("spaBooking.per_person")}
                                  </Text>
                                </Text>

                              </View>
                            </View>
                          </View>
                      }
                      else if(bookingShowType=== "ONLINE") {
                        return <CustomPressable 
                          style={getStyles(["list_itemContainer", "spaBooking1aOnlineListItem"])}
                          id="spaBooking1aOnlineListItem"
                          onPress={()=>{
                            setSelectedService({
                              name: data.name,
                              service: service,
                            });
                          }}
                        >

                          <CustomCheckBoxWithProps 
                            value={selectedService && service?.id == selectedService.service?.id}
                            onValueChange={()=> {}}
                            checkBoxStyle={getStyles(["spaBooking1aOnlineListItemCheckbox"])}
                            id="spaBooking1aOnlineListItemCheckbox"
                          />

                          <View style={getStyles(["list_itemContainer_textContainer", "spaBooking1aOnlineListItemDetails"])} id='spaBooking1aOnlineListItemDetails'>
                            <Text style={getStyles(["list_itemContainer_textContainer_title", "spaBooking1aOnlineListItemDetailsName"])} id='spaBooking1aOnlineListItemDetailsName'>{makeStringStrictlyCapitalize(service.name)}</Text>
                            {service.description && <Text style={getStyles(["spaBooking1aOnlineListItemDetailsDescription"])} id='spaBooking1aOnlineListItemDetailsDescription'>{service.description}</Text>}

                            <View style={getStyles(["spaBooking1aOnlineListItemDetailsContainer"])} id='spaBooking1aOnlineListItemDetailsContainer'>
                              <Text style={getStyles(["spaBooking1aOnlineListItemDetailsMinutes"])} id='spaBooking1aOnlineListItemDetailsMinutes'>{`${service.duration} ${t("spaBooking.minutes")}`}</Text>
                              
                              <Text style={getStyles(["spaBooking1aOnlineListItemDetailsPrice"])} id='spaBooking1aOnlineListItemDetailsPrice'>
                                {`${currencyCode} ${service.price}`}
                                <Text style={getStyles(["spaBooking1aOnlineListItemDetailsPerson"])} id='spaBooking1aOnlineListItemDetailsPerson'>{t("spaBooking.per_person")}</Text>
                              </Text>
                            </View>
                          </View>

                        </CustomPressable>
                      }
                      else {
                        return<>
                          <View style={getStyles(["list_itemContainer", "spaBooking1aListItemElseContainer"])} id="spaBooking1aListItemElseContainer">
                            <Text style={getStyles(["list_itemContainer_textContainer_title", "spaBooking1aListItemElseName"])} id='spaBooking1aListItemElseName'>{makeStringStrictlyCapitalize(service.name)}</Text>
                            <Text style={getStyles(["list_itemContainer_textContainer_subtitle", "spaBooking1aListItemElseDescription"])} id='spaBooking1aListItemElseDescription'>{service.description}</Text>

                            <Text style={getStyles(["spaBooking1aListItemElseContactHotel"])} id='spaBooking1aListItemElseContactHotel'>{t(`spaBooking.contact_hotel`)}</Text>
                            
                            <View style={getStyles(["spaBooking1aListItemElseDetails"])} id='spaBooking1aListItemElseDetails'>
                              <Text style={getStyles(["spaBooking1aListItemElseDetailsDuration"])} id='spaBooking1aListItemElseDetailsDuration'>{`${service.duration} ${t("spaBooking.minutes")}`}</Text>

                              <Text style={getStyles(["spaBooking1aListItemElseDetailsPrice"])} id='spaBooking1aListItemElseDetailsPrice'>
                                {`${currencyCode} ${service.price}`}
                                <Text style={getStyles(["spaBooking1aListItemElseDetailsPerson"])} id='spaBooking1aListItemElseDetailsPerson'>{t("spaBooking.per_person")}</Text>
                              </Text>
                            </View>
                            
                          </View>

                          <CustomPressable 
                            style={getStyles(["spaBooking1aListItemElseButtonContainer"])}
                            id="spaBooking1aListItemElseButtonContainer"
                            onPress={()=> {
                              setSelectedService({
                                name: data.name,
                                service: service,
                              });
                            }}
                          >
                            <CustomCheckBoxWithProps 
                              value={selectedService && service.id == selectedService.service.id}
                              onValueChange={()=> {}}
                              checkBoxStyle={getStyles(["spaBooking1aListItemElseButtonCheckbox"])}
                            />

                            <View style={getStyles(["spaBooking1aListItemElseButtonDetails"])} id='spaBooking1aListItemElseButtonDetails'>
                              <Text style={getStyles(["spaBooking1aListItemElseButtonDetailsName"])} id='spaBooking1aListItemElseButtonDetailsName'>
                                {makeStringStrictlyCapitalize(service.name)}
                              </Text>
                              <Text style={getStyles(["spaBooking1aListItemElseButtonDetailsDescription"])} id='spaBooking1aListItemElseButtonDetailsDescription'>
                                {service.description}
                              </Text>

                              <View style={getStyles(["spaBooking1aListItemElseButtonDetailsContainer"])} id='spaBooking1aListItemElseButtonDetailsContainer'>
                                <Text style={getStyles(["spaBooking1aListItemElseButtonDetailsDuration"])} id='spaBooking1aListItemElseButtonDetailsDuration'>
                                  {`${service.duration} ${t("spaBooking.minutes")}`}
                                </Text>
                                
                                <Text style={getStyles(["spaBooking1aListItemElseButtonDetailsPrice"])} id='spaBooking1aListItemElseButtonDetailsPrice'>
                                  {`${currencyCode} ${service.price}`}
                                  <Text style={getStyles(["spaBooking1aListItemElseButtonDetailsPerson"])} id='spaBooking1aListItemElseButtonDetailsPerson'>
                                    {t("spaBooking.per_person")}
                                  </Text>
                                </Text>
                              </View>
                            </View>
                          </CustomPressable>
                        </>
                      }
                    })}
                  </View>
              })}
            </View>
            
          </View>
        </ScrollView>

        <View id='spaBookingNextButtonContainer' style={getStyles(['spaBookingNextButtonContainer'])}>
          <CustomPressable style={getStyles(['primaryBtn'])} onPress={()=> handleNext(selectedService)} id="primaryBtn" disabled={!selectedService}>
              <Text style={getStyles(["primaryBtnTxt"])} id='primaryBtnTxt'>
                  {t("spaBooking.next")}
              </Text>
          </CustomPressable>
          <CustomPressable style={getStyles(["secondaryBtn"])} onPress={()=> handleGoBack()} id="secondaryBtn">
              <Text style={getStyles(["secondaryBtnTxt"])} id='secondaryBtnTxt'>
                  {t("spaBooking.back")}
              </Text>
          </CustomPressable>
        </View>
      </View>
    )
}


const areAllServiceInDataNoShow = (data) =>{
  return data.services.every((service)=> getBookingShowType(toBool(service.onlineEnabled) , toBool(service.callToBook))=== "NOSHOW");
}

const getBookingShowType = (onlineEnabled, callToBook) =>{
  // 1. onlineEnabled = true  and  callToBook = false  ---> show online booking
  // 2. onlineEnabled = true  and  callToBook = true ---> show online booking ( currently showing offline booking but should show online booking)
  // 3. onlineEnabled = false  and  callToBook = true ---> show offline booking
  // 4. onlineEnabled = false  and  callToBook = false ---> Don't show in the list. (currently still showing as online booking)

  if( onlineEnabled === undefined  || callToBook === undefined ) return 'ONLINE';

  if( onlineEnabled && !callToBook ) return 'ONLINE';
  if( onlineEnabled && callToBook ) return 'ONLINE-OFFLINE';
  if( !onlineEnabled && callToBook ) return 'OFFLINE';
  if( !onlineEnabled && !callToBook ) return 'NOSHOW';
  
  return "";
}

export default SpaBooking1a
